<template>
      <section class="form-fields-third-to-add flex-column">
        <!-- THE COMPANY : NAME -->
        <form-fields-companies-list
        v-if="hasCompany" 
        :company="company"
        class="br b-1-gray-05 gray-0-bkg px-3"
        :overview="false"
        :allowEdit="true"
        :allowRemove="true"
        allowBadge
        :third="third"
        prop="companySelected"
        @remove-company="remove"
        @edit-company="edit"
        :dataBotsContext="currentStore"/>

        <!-- if no company selected -->
        <el-form-item v-if="!hasCompany" prop="companyName" :label="searchLabel">
            <dropdown-search-third
                :searchDisabled="searchDisabled"
                ref="dropdownSearchThird"
                :currentStore="currentStore"
                :value="name"
                :third="third"
                @update="setThird"
            />
        </el-form-item>

      </section>
</template>

<script>
    import DropdownSearchThird from 'vcomponents/inputs/custom/DropdownSearchThird.vue';
    import FormFieldsCompaniesList from './FormFieldsCompaniesList.vue';
    import DataBotsFormsMixins from "mixins/DataBotsFormsMixins";

    import { createNamespacedHelpers } from 'vuex'
    const  popupPanelMapActions  = createNamespacedHelpers('popupPanel').mapActions;

    export default {
        mixins:[DataBotsFormsMixins],
        props: {
            currentStore: {
                type: String,
                required: true
            },
            lightForm: {
                type: Boolean,
                required : false,
                default: false
            },
            third: {
                required: false,
                type: String,
                default: "company"
            }
        },
        components:{
            DropdownSearchThird,
            FormFieldsCompaniesList,
        },
        computed:{
            hasCompany(){
                return (!!this.name)
            },
            company(){
                return this.$store.getters[`${this.currentStore}/getThird`]
            },
            name(){
                const name = this.$store.getters[`${this.currentStore}/getThirdName`];
                return !_.isNil(name) ? name : "";
            },
            state(){
                return this.$store.getters[`${this.currentStore}/getState`]
            },
            searchDisabled(){
                return this.third !== "company" || !this.$store.getters[`${this.currentStore}/getSearchAvailable`];
            },
            searchLabel(){
                return this.third === "company" ? this.$l10n.__('Nom de la société') : this.$l10n.__('Nom');
            },
            hasContacts(){
                return this.$store.getters[`${this.currentStore}/getContacts`]?.length > 0;
            }
        },
        methods:{
            ...popupPanelMapActions([
                'open'
            ]),
            /**
             * Open a popup throught call of open() from popupPanel.js
             */
            openEditPopUp(type, subType){
                this.open({
                    key: `popupThirdForm`,
                    props: {
                        options: {
                            types: {type : type, subType: subType},
                            id: null,
                            action: "create"
                        },
                        current : this.currentStore,
                        defaultValue: this.company,
                    }
                })
            },
            openWarningPopUp(){
                this.open({
                    key: `popupWarningThirdForm`,
                    props: { 
                        currentStore: this.currentStore,
                        contextType: "cancelThird"
                    }
                });
            },
            setThird(company){
                this.$store.commit(`${this.currentStore}/setLoading`, true);
                this.$store.commit(`${this.currentStore}/setThird`, company)
                if(company && company.name){
                    this.$store.dispatch(`${this.currentStore}/fetchThirdCustomFields`, company.id)
                    .then((res)=>{
                        this.$store.commit(`${this.currentStore}/setThirdCustomFields`, res);
                        if(company.third === "company"){
                            this.$store.dispatch(`${this.currentStore}/fetchContacts`, company)
                            .then(()=>{
                                if(!this.hasCompany){
                                    this.removeThird();
                                }
                            });
                        }else{
                            this.$store.commit(`${this.currentStore}/setLoading`, false);
                        }
                    }).catch(()=>{
                        Push.error(this.$l10n.__("Une erreur s'est produite lors de la récupération des contacts."), false)
                    })
                }
            },
            
            remove(){
                !this.hasContacts ? this.removeThird() : this.openWarningPopUp();
            },
            removeThird(){
                this.$store.dispatch(`${this.currentStore}/resetCompany`);
            },
            edit(company){
                !_.isNil(this.lightForm) ? this.openEditPopUp(this.third, company.type) : this.editThird(company);
            },
            editThird(company){
                const params = {
                    linkedCompany: {...company.object},
                    linkedForm: {new: "", name: this.currentStore, back: true, state : this.state }
                }
                this.$router.push({name: "company.form", params: params})
            }
        }
    }
</script>

<style lang="scss">
    .form-fields-company-to-add .form-fields-companies-list{
        line-height: 34px;
    }

    .dropdown-search-third__list .el-dropdown-menu__item{
        padding-left: 0;
        padding-right: 0;
    }
</style>
